import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { TextFieldRules } from '@/utils/enums'

interface TimeRangeFieldsProps {
  start: string
  end: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TimeRangeFields',
  props: {
    start: null,
    end: null
  },
  emits: [
  'update:start',
  'update:end',
  'focus:start',
  'focus:end',
],
  setup(__props: any, { emit }) {

const props = __props as {
  start: string
  end: string
};




const localStart = computed({
  get() {
    return props.start
  },
  set(value) {
    emit('update:start', value)
  },
})

const localEnd = computed({
  get() {
    return props.end
  },
  set(value) {
    emit('update:end', value)
  },
})

const isValidStart = computed(() => {
  return (
    TextFieldRules.TIME_STRING(localStart.value) === true &&
    localStart.value.trim().length > 0
  )
})

return { __sfc: true,props, emit, localStart, localEnd, isValidStart, TextFieldRules }
}

})